import styled from 'styled-components';
import { fadeInAndUp } from '../../../constants/keyframes/fades';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import { Column, Columns } from '../../base/grid';
import RichTextTitle from '../../base/richTextTitle';

export const ResultWrapper = styled.div`
	margin-top: 80px;
	align-self: stretch;
`;

export const ResultError = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	animation: ${fadeInAndUp} 300ms ease;

	svg {
		max-height: 500px;
		max-width: 100%;
	}
`;

export const ErrorMessage = styled(RichTextTitle)`
	margin-block: 32px;
`;

export const ErrorDescription = styled.div`
	&:not(:last-child) {
		margin-bottom: 32px;
	}

	${media.tablet`
		max-width: 540px;
	`};
`;

export const ResultContentContainer = styled.div`
	animation: ${fadeInAndUp} 300ms ease;
`;

export const ShipmentInfoWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	flex-wrap: wrap;
	padding: 12px 12px 20px;
	border: 1px solid ${theme.colorsV2.grey5};
	border-radius: 8px;

	${media.desktopSmall`
		flex-direction: row;
		justify-content: space-around;
		padding: 26px 34px 34px;
	`};
`;

export const ShipmentInfoItem = styled.div`
	margin-top: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;

	${media.mobileLarge`
		flex-direction: row;
	`};

	${media.desktopSmall`
		margin: 8px 8px 0;
		width: auto;
	`};
`;

export const ShipmentInfoLabel = styled.span`
	color: ${theme.colorsV2.grey6};

	${media.mobileLarge`
		flex: 0 1 50%;
		padding-right: 12px;
		text-align: right;
	`};

	${media.desktopSmall`
		flex: 0 0 auto;
		padding-right: 8px;
	`};
`;

export const ShipmentInfoValue = styled.span`
	flex: 1 0 50%;
	font-weight: ${theme.fonts.weight.medium};
	color: ${theme.colorsV2.mainDark};

	${media.mobileLarge`
		align-self: flex-end;
	`};

	${media.desktopSmall`
		flex: 0 0 auto;
	`};
`;

export const TimelineWrapper = styled.div`
	margin-top: 64px;
	text-align: center;
	color: ${theme.colorsV2.mainDark};
`;

export const TimelineEventTitle = styled(RichTextTitle)`
	margin-bottom: 32px;
`;

export const TimelineEventRow = styled(Columns)`
	display: flex;
	flex-wrap: wrap;
`;

export const TimelineEventDate = styled(Column)`
	margin-bottom: 0;
	text-align: right;
`;

export const TimelineMobileEventDate = styled.div``;

export const TimelineEventDotWrapper = styled(Column)`
	margin-bottom: 0;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding-top: 9px;
`;

export const TimelineEventDot = styled.div`
	width: 8px;
	height: 8px;
	background: ${theme.colorsV2.mainRed};
	border-radius: 50%;
`;

export const TimelineEventLine = styled.div`
	margin-block: 16px 7px;
	width: 2px;
	height: 72px;
	background-color: ${theme.colorsV2.grey3};
	border-radius: 2px;

	${media.tablet`
        height: 52px;
	`};
`;

export const TimelineEventInfoWrapper = styled(Column)`
	margin-bottom: 0;
	text-align: left;
`;

export const TimelineEventDescription = styled.div``;

export const TimelineEventLocation = styled.div`
	margin-top: 4px;
	font-size: 14px;
	line-height: 1.2;
	color: ${theme.colorsV2.grey6};
`;
